import aiConfig from "./ai/aiConfig";
import usersConfig from "./users/usersConfig";

export const projectConfig = [aiConfig, usersConfig];



// WEBPACK FOOTER //
// ./src/main/content/project/projectConfig.js